module.exports = __webpack_public_path__ + "img/30.5fc3b295.png";